import { useState, useEffect } from "react";

import { AgentDetailAccessSourceEnum } from "@/api/generated";
import { PropallyApiFactory } from "@/module/CustomApiFactory";

interface UseAgentDetailAccessLog {
  logAgentDetailAccess: (agentId: number, source: AgentDetailAccessSourceEnum) => Promise<void>;
  loading: boolean;
  error: string | null;
}

export const useAgentDetailAccessLog = (
  agentId?: number,
  source?: AgentDetailAccessSourceEnum
): UseAgentDetailAccessLog => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fp = PropallyApiFactory();

  const logAgentDetailAccess = async (agentId: number, source: AgentDetailAccessSourceEnum) => {
    try {
      setLoading(true);
      setError(null);

      await fp.v1AgentDetailAccessLogsPost(
        {
          agent_id: agentId,
          source: source,
        },
        { withCredentials: true }
      );

      setLoading(false);
    } catch (e) {
      setError(e);
      setLoading(false);
    }
  };

  // 自動ログ送信
  useEffect(() => {
    if (agentId && source) {
      logAgentDetailAccess(agentId, source);
    }
  }, [agentId, source]);

  return { logAgentDetailAccess, loading, error };
};
